import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { DoctorService } from '../../_services/doctor.service';

import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-doc-detail',
  templateUrl: './doc-detail.component.html',
  styleUrls: ['./doc-detail.component.css']
})
export class DocDetailComponent implements OnInit {
  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  doctorid: string;
  returnUrl: string;
  id: string;
  doctors: any;
  imgKey: string = environment.imgKey;
  encodedKey: string;
  degree: string;
  specialities: string;
  specialisations: string;
  languages: string;

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private doctorservice: DoctorService, private toaster: ToasterService) { }

  ngOnInit() {
    this.encodedKey = btoa(this.imgKey);
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    } 
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';



    this.id = this.route.snapshot.params.id;
    this.getDoctorById(this.id);
  }

  getDoctorById(id) {
    this.doctorservice.getDoctorById(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.doctors = data.doctorsList[0];

            let degrees = this.doctors.degrees.map((name) => (name.name));
            this.degree = degrees.toString();

            let specialities = this.doctors.specialities.map((name) => (name.name));
            this.specialities = specialities.toString();

            let specialisations = this.doctors.specialisations.map((name) => (name.name));
            this.specialisations = specialisations.toString();

            let languages = this.doctors.languages.map((name) => (name.name));
            this.languages = languages.toString();

          } else {
            this.toaster.showError('Doctor', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Doctor', error.error.ResponseMessage);
        });
  }

}
